/* Adds thousands separator to the value */
export function numberFormat(value: number) {
  if (isNaN(value)) return ''

  return value.toLocaleString('en-US')
}
